import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Settings } from '../../lib/app.constant';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdministrationService {
  private privilegeListSource = new BehaviorSubject<any>([]);
  privilegeList$ = this.privilegeListSource.asObservable();

  constructor(private http: HttpClient) { }

  setPrivilegeList(privilegeList: any[]) {
    this.privilegeListSource.next(privilegeList);
  }

  getAllUser(body: {}, isExport: boolean=false) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl+ 'user/v1/list', body);
    }
    else {
      return this.http.post(environment.baseApiUrl+ 'user/v1/list', body, { observe: 'response', responseType: 'blob' });
    }
  }
  getAssignableUserList(name: string = "") {
    return this.http.get<any>(environment.baseApiUrl + 'user/v1/short-info?name=' + name);
  }
  getVendorById(vendor: number) {
    return this.http.get(environment.baseApiUrl + `vendor/v1/vendor-data/${vendor}`);
  }
  addUser(body:{}){
    return this.http.post(environment.baseApiUrl+ 'user/v1/add-user', body);
  }

  updateUser(body:{},id:string){
    return this.http.put(environment.baseApiUrl+ 'user/v1/'+id, body);
  }
  changeSuperUser(body:{},id){
    return this.http.put(environment.baseApiUrl+'user/v1/superuser/modify/'+id,body);
  }
  deleteUser(id:string){
    return this.http.delete(environment.baseApiUrl+ 'user/v1/'+id);
  }

  getApplicationRoleDataAccess(id){
   return this.http.get(environment.baseApiUrl+'user/v1/user/profile/access/'+id)
  }
    getColumnSettingsList(body: any) {
      return this.http.post(environment.baseApiUrl+'configuration/v1/column-configuration/list',body);
    }

    getModuleKey(moduleId:number){
      return this.http.get(environment.baseApiUrl+`configuration/api/module/${moduleId}/dropdown-fields/`)
    }

  getUserColumnSettingsList(module_id,application_id){
    return this.http.get(environment.baseApiUrl+'config/v1/user-column-settings/list/module/'+module_id+'/application/'+application_id);
  }
  getModuleUrlDropdown(module_id: number) {
    return this.http.get(`${environment.baseApiUrl}configuration/module/${module_id}`);
  }
  postUserColumnSettings(body){
    return this.http.post(environment.baseApiUrl+'config/v1/user-column-settings',body);
  }

    //  *---------------Masterdata Document Type-----------------*
    getDocumentType(body: {}, is_export: boolean = false) {
      if(is_export){
        return this.http.post(environment.baseApiUrl + `document/v1/document-type/list`, body, { observe: 'response', responseType: 'blob' });
      }else{
      return this.http.post(environment.baseApiUrl + `document/v1/document-type/list`, body);
      }
    }
    postDocumentType(body: {}) {
      return this.http.post(environment.baseApiUrl + 'document/v1/document-type', body);
    }
    deleteDocumentType(id) {
      return this.http.delete(environment.baseApiUrl + `document/v1/document-type/${id}`);
    }
    updateDocumentType(body: {}, id) {
      return this.http.put(environment.baseApiUrl + `document/v1/document-type/${id}`, body);
    }

    //  *---------------Masterdata Document Field-----------------*
    getDocumentFieldConfig(body, is_export: boolean = false) {
      if(is_export){
        return this.http.post(environment.baseApiUrl + `configuration/v1/document-field/library/list`, body, { observe: 'response', responseType: 'blob' });
      }else{
      return this.http.post<any>(environment.baseApiUrl + `configuration/v1/document-field/library/list`, body);
      }
    }
    postDocumentField(body: {}) {
      return this.http.post(environment.baseApiUrl + 'configuration/v1/document-field/library', body);
    }
    deleteDocumentField(id) {
      return this.http.delete(environment.baseApiUrl + `configuration/v1/document-field/library/${id}`);
    }
    updateDocumentField(body: {}, id) {
      return this.http.put(environment.baseApiUrl + `configuration/v1/document-field/library/${id}`, body);
    }

  postDocumentFieldLibrary(body){
    return this.http.post(environment.baseApiUrl+ 'configuration/v1/document-field/library', body);
  }

  getDocumentFieldLibrary(body){
    return this.http.post(environment.baseApiUrl+ 'configuration/v1/document-field/library/list', body);
  }

  getUrlDropdown(id){
    return this.http.get(environment.baseApiUrl+ `configuration/api/column-keys/${id}`);
  }

  getRoleList(body: {}, isExport: boolean=false) {
    if (!isExport) {
      return this.http.post(environment.baseApiUrl+ 'acl/v1/role/list', body);
    }
    else {
      return this.http.post(environment.baseApiUrl+ 'acl/v1/role/list', body, { observe: 'response', responseType: 'blob' });
    }
  }

  submitColumnSetting(body:{}){
    return this.http.post(environment.baseApiUrl+ 'configuration/v1/column-configuration', body);
  }

  addRole(body:{}){
    return this.http.post(environment.baseApiUrl+ 'acl/v1/role', body);
  }

  updateRole(body:{},id:string){
    return this.http.put(environment.baseApiUrl+ 'acl/v1/role/'+id, body);
  }

  deleteRole(id:string){
    return this.http.delete(environment.baseApiUrl+ 'acl/v1/role/'+id);
  }

  getPrivilegelist(body:{}){
    return this.http.post(environment.baseApiUrl+"acl/v1/privilege/list",body);
  }
  getVendorListByAccountNumber(account_number:any){
    return this.http.get<any>(environment.baseApiUrl+"ticket/v1/vendor-map-list/"+account_number);
  }
  updateVendor(payload: any): Observable<any> {
    return this.http.post<any>(  environment.baseApiUrl + 'ticket/v1/update-vendor',  payload );
  }
  subscribeToTicket(body: {}) {
    return this.http.post(environment.baseApiUrl + "ticket/v1/ticket-email-subscription", body);
  }
  cancelTicketStatus(body: {}) {
    return this.http.post(environment.baseApiUrl + "ticket/v1/status-change", body);
  }
  unblockVendor(payload: any): Observable<any> {
    return this.http.post<any>(environment.baseApiUrl + 'ticket/v1/unblock-vendor', payload);
  }
  extendVendor(payload: any): Observable<any> {
    return this.http.post<any>(environment.baseApiUrl + 'ticket/v1/extend-vendor', payload);
  }
  getSanctionedVendorsByVendorId(vendorId: number) {
    return this.http.get<any>(environment.baseApiUrl + `vendor/v1/vendor-master-records/${vendorId}`);
  }
  getVendorSelected(body:{}){
    return this.http.post(environment.baseApiUrl+"ticket/v1/ticket-action",body);
  }
  blockSelectedVendor(body:{}){
    return this.http.post(environment.baseApiUrl+"ticket/v1/block-vendor",body);
  }

    getLegalEntitiesByD365(account_number: any, request_type: number) {
    return this.http.get<any>(`${environment.baseApiUrl}vendor/v1/d365-legal-entity/${account_number}?request_type=${request_type}` );
  }

  getLegalEntitysByLs(source_system_id: any, request_type: number) {
    return this.http.get<any>(`${environment.baseApiUrl}vendor/v1/ls-legal-entity/${source_system_id}?request_type=${request_type}`);
  }
  getOrganizationList(source_system_id:any,  request_type: number){
    return this.http.get<any>( `${environment.baseApiUrl}vendor/v1/velocity-organisation/${source_system_id}?request_type=${request_type}`);
  }

    getSerticaUnitsBySourceSystem(body: any, request_type: number) {
        return this.http.post<any>(`${environment.baseApiUrl}master/v1/sertica/le/list?request_type=${request_type}`,body);
    }
  //  *---------------Administration Application-----------------*
  getApplicationList(body, is_export: boolean = false) {
    if(is_export){
      return this.http.post(environment.baseApiUrl + `user/v1/application/list`, body, { observe: 'response', responseType: 'blob' });
    }else{
    return this.http.post<any>(environment.baseApiUrl + `user/v1/application/list`, body);
    }
  }
  getApplicationListShortInfo() {
    return this.http.get<any>(environment.baseApiUrl + `user/v1/application/short/info`);
  }
  getApplicationLogo(application_id) {
    return this.http.get(environment.baseApiUrl + 'user/v1/application/logo/'+application_id);
  }
  generateAppApiToken(body: {}) {
    return this.http.post(environment.baseApiUrl + 'user/v1/token/generate', body);
  }
  reGenerateAppApiToken(body: {},token_id ) {
    return this.http.post(environment.baseApiUrl + 'user/v1/token/reset/'+token_id , body);
  }
  getAppApiToken(id) {
    return this.http.get(environment.baseApiUrl + 'user/v1/tokens/'+id);
  }
  postApplication(body: {}) {
    return this.http.post(environment.baseApiUrl + 'user/v1/application/register', body);
  }
  deleteApplication(id) {
    return this.http.delete(environment.baseApiUrl + `user/v1/application/${id}`);
  }
  updateApplication(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `user/v1/application/modify/${id}`, body);
  }

  getApplicationPrivilegeList(body) {
    return this.http.post<any>(environment.baseApiUrl + `document/v1/user/application/privilege/list`,body);
  }

  getApplicationPrivileges(){
    return this.http.get<any>(environment.baseApiUrl + `user/v1/application/privilege`);
  }

  getUserDocumentTypeList(body) {
    return this.http.post<any>(environment.baseApiUrl + `document/v1/user/document-type/list`,body);
  }
  getUserBusinessUnitList(body) {
    return this.http.post<any>(environment.baseApiUrl + `document/v1/user/business-unit/list`,body);
  }

    //  *---------------Administration Announcement-----------------*
    getAnnouncementList(body, is_export: boolean = false) {
      if(is_export){
        return this.http.post(environment.baseApiUrl + `notification/v1/announcement/admin/list`, body, { observe: 'response', responseType: 'blob' });
      }else{
      return this.http.post<any>(environment.baseApiUrl + `notification/v1/announcement/admin/list`, body);
      }
    }
    postAnnouncement(body: {}) {
      return this.http.post(environment.baseApiUrl + 'notification/v1/announcement', body);
    }
    deleteAnnouncement(id) {
      return this.http.delete(environment.baseApiUrl + `notification/v1/announcement/${id}`);
    }

    getAnnouncementFile(id: number) {
        return this.http.get<{ file_content: string }>(
          environment.baseApiUrl + `notification/v1/announcement/file/${id}`
        );
      }

    //  *---------------Administration Application Email Template-----------------*

    getEmailTemplate(body, is_export: boolean = false) {
        if (is_export) {
          return this.http.post(environment.baseApiUrl + `email/email_template/manual/list`, body, { observe: 'response', responseType: 'blob' });
        } else {
          return this.http.post<any>(environment.baseApiUrl + `email/email_template/manual/list`, body);
        }
    }

    postEmailTemplate(body: {}) {
      return this.http.post(environment.baseApiUrl + 'email/v1/email_template/manual/create', body);
    }

    getEmailTypeList(body: {}) {
      return this.http.post(environment.baseApiUrl + 'email/v1/email_template/email_type/list', body);
    }
    deleteEmailTemplateManual(id: number) {
      return this.http.delete(environment.baseApiUrl + `email/v1/email_template/manual/${id}`);
    }
    updateEmailTemplateManual(body: {}, id) {
        return this.http.put(environment.baseApiUrl + `email/v1/email_template/manual/${id}`, body);
    }
    // Auto Email Template methods
    getAutoEmailTemplateList(body, is_export: boolean = false) {
        if (is_export) {
            return this.http.post(environment.baseApiUrl + `email/email_template/auto/list`, body, { observe: 'response', responseType: 'blob' });
          } else {
            return this.http.post<any>(environment.baseApiUrl + `email/email_template/auto/list`, body);
          }
    }

    postAutoEmailTemplate(body: {}) {
      return this.http.post(environment.baseApiUrl + 'email/email_template/auto/create', body);
    }

    deleteAutoEmailTemplate(id: number) {
      return this.http.delete(environment.baseApiUrl + `email/v1/email_template/auto/${id}`);
    }

    updateAutoEmailTemplate(body: {}, id) {
      return this.http.put(environment.baseApiUrl + `email/v1/email_template/auto/${id}`, body);
    }
    uploadEmailTemplateAttachment(body: FormData) {
        return this.http.post(environment.baseApiUrl + 'email/v1/email_template/attachment/insert', body);
    }
    downloadEmailTemplateAttachment(fileName: string): Observable<Blob> {
        return this.http.get(`${environment.baseApiUrl}email/v1/email-template-attachments/${fileName}`, { responseType: 'blob' });
    }
    deleteAttachment(attachmentId: number) {
        return this.http.post(environment.baseApiUrl + `email/v1/email_template/attachment`, { attachments: [attachmentId] });
    }
    // Email Controller methods
     getEmailControllerList(body, is_export: boolean = false) {
        if (is_export) {
            return this.http.post(environment.baseApiUrl + `email/v1/email_template/controller/list`, body, { observe: 'response', responseType: 'blob' });
          } else {
            return this.http.post<any>(environment.baseApiUrl + `email/v1/email_template/controller/list`, body);
          }
    }
    postEmailController(body: {}) {
      return this.http.post(environment.baseApiUrl + 'email/v1/email_template/controller/create', body);
    }

    deleteEmailController(id: number) {
      return this.http.delete(environment.baseApiUrl + `email/v1/email_template/controller/${id}`);
    }

    updateEmailController(body: {}, id: number) {
      return this.http.put(environment.baseApiUrl + `email/v1/email_template/controller/${id}`, body);
    }


      //  *---------------Administration RetentionPolicy-----------------*
  getRetentionPolicyList(body, is_export: boolean = false) {
    if(is_export){
      return this.http.post(environment.baseApiUrl + `admin/v1/retention/policy/list`, body, { observe: 'response', responseType: 'blob' });
    }else{
    return this.http.post<any>(environment.baseApiUrl + `admin/v1/retention/policy/list`, body);
    }
  }
  postRetentionPolicy(body: {}) {
    return this.http.post(environment.baseApiUrl + 'admin/v1/retention/policy', body);
  }
  deleteRetentionPolicy(id) {
    return this.http.delete(environment.baseApiUrl + `admin/v1/retention/policy/${id}`);
  }
  updateRetentionPolicy(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `admin/v1/retention/policy/${id}`, body);
  }


  getUserActivityLogs(body, is_export: boolean = false) {
    if(is_export){
      return this.http.post(environment.baseApiUrl + `user/v1/admin/user-activity/list`, body, { observe: 'response', responseType: 'blob' });
    }else{
    return this.http.post<any>(environment.baseApiUrl + `user/v1/admin/user-activity/list`, body);
    }
  }

  getEmailLogs(body, is_export: boolean = false) {
    if(is_export){
      return this.http.post(environment.baseApiUrl + `document/v1/email/log`, body, { observe: 'response', responseType: 'blob' });
    }else{
    return this.http.post<any>(environment.baseApiUrl + `document/v1/email/log`, body);
    }
  }

  getDataChangeLogs(body, is_export: boolean = false) {
    if(is_export){
      return this.http.post(environment.baseApiUrl + `notification/v1/history/data_change/log`, body, { observe: 'response', responseType: 'blob' });
    }else{
    return this.http.post<any>(environment.baseApiUrl + `notification/v1/history/data_change/log`, body);
    }
  }

      //  *---------------Administration RetentionPolicy-----------------*
      getAppDocConfigList(body, is_export: boolean = false) {
        if(is_export){
          return this.http.post(environment.baseApiUrl + `document/v1/application/document/type/list`, body, { observe: 'response', responseType: 'blob' });
        }else{
        return this.http.post<any>(environment.baseApiUrl + `document/v1/application/document/type/list`, body);
        }
      }
      postAppDocConfig(body: {}) {
        return this.http.post(environment.baseApiUrl + 'document/v1/application/document/type', body);
      }
      deleteAppDocConfig(id) {
        return this.http.delete(environment.baseApiUrl + `document/v1/application/document/type/${id}`);
      }
      updateAppDocConfig(body: {}, id) {
        return this.http.put(environment.baseApiUrl + `document/v1/application/document/type/${id}`, body);
      }

        //  *---------------Masterdata File Type-----------------*
  getFileTypeList(body, is_export: boolean = false) {
    if(is_export){
      return this.http.post(environment.baseApiUrl + `master/v1/file-type/list`, body, { observe: 'response', responseType: 'blob' });
    }else{
    return this.http.post<any>(environment.baseApiUrl + `master/v1/file-type/list`, body);
    }
  }
  postFileType(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/file-type', body);
  }
  deleteFileType(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/file-type/${id}`);
  }
  updateFileType(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/file-type/${id}`, body);
  }
    getSlaList(body, is_export: boolean = false) {
    if(is_export){
      return this.http.post(environment.baseApiUrl + `ticket/v1/sla/list`, body, { observe: 'response', responseType: 'blob' });
    }else{
    return this.http.post<any>(environment.baseApiUrl + `ticket/v1/sla/list`, body);
    }
  }
  postSla(body: {}) {
    return this.http.post(environment.baseApiUrl + 'ticket/v1/sla', body);
  }
  deleteSla(id) {
    return this.http.delete(environment.baseApiUrl + `ticket/v1/sla/${id}`);
  }
  updateSla(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `ticket/v1/sla/${id}`, body);
  }

  saveFilterTemplate(body:{}){
    return this.http.post(environment.baseApiUrl+'user/v1/user-preference',body);
  }

  getFilterTemplateList(body:{}){
    return this.http.post(environment.baseApiUrl+'user/v1/user-preference/filter-template/list',body);
  }
  deleteFilterTemplateById(module_id:{}){
    return this.http.delete(environment.baseApiUrl+'user/v1/user-preference/destroy/'+module_id);
  }
  preparePayload(payload: any): any {
    const filteredPayload = { ...payload };
    Object.keys(filteredPayload).forEach(key => {
      const startDateKey = `${key}_start_date`;
      const endDateKey = `${key}_end_date`;
      if (filteredPayload[startDateKey]) {
        if (filteredPayload[endDateKey] == null) { // Check if end_date is null or undefined
          filteredPayload[endDateKey] = filteredPayload[startDateKey];
          delete filteredPayload[key];
        } else if (filteredPayload[startDateKey] && filteredPayload[endDateKey]) {
          delete filteredPayload[key];
        }
      }else{
        if (typeof filteredPayload[key] == 'string') {
    filteredPayload[key] = filteredPayload[key]?.trim();
    filteredPayload[key] = filteredPayload[key] == '' ? null : filteredPayload[key];
  }
        if (key !== 'is_active' &&  !key.endsWith('_start_date') && !key.endsWith('_end_date') && !Array.isArray(filteredPayload[key]) && filteredPayload[key] != null) {
          filteredPayload[key] = [filteredPayload[key]];
        }
      }
    });
    return filteredPayload;
  }

  initializeFilterModel(column_list) {
    let filterModel={};
    column_list.forEach(col => {
      if (col.is_filterable) {
        if (col.filter_type === 'calendar') {
          filterModel[`${col.key}_start_date`] = null;
          filterModel[`${col.key}_end_date`] = null;
        }
        else if(col.filter_type === 'input'){
           if (col.key.endsWith('_by')) {
            filterModel[col.key] = null;
            filterModel[`${col.key}_name`] = null;
        }
        else if (col.key.endsWith('_to')) {
          filterModel[col.key] = null;
          filterModel[`${col.key}_name`] = null;
      }
        else{
          filterModel[col.key] = null;
        }
        }
        else {
          filterModel[col.key] = null;
        }
      }
    });
    return filterModel;
  }

  groupData(listData: any[]) {
    // Initialize groups
    if (!listData || listData.length === 0) {
      return [];
    }
    
    const activeData = listData?.filter(app => app.is_active);
    const inactiveData = listData?.filter(app => !app.is_active);

    // Create grouped list with headers
     let groupedList = [];

    if (activeData.length > 0) {
       groupedList.push({
        label: 'Active',
        items: activeData
      });
    }

    if (inactiveData.length > 0) {
       groupedList.push({
        label: 'Inactive',
        items: inactiveData
      });
    }

    return groupedList;
  }

  charToPx(text: string, fontSize: string = '12px', fontFamily: string = 'DFDS-Regular'): number {
    const span = document.createElement('span');
    span.style.position = 'absolute';
    span.style.visibility = 'hidden';
    span.style.font = `${fontSize} ${fontFamily}`;
    span.textContent = text;
    document.body.appendChild(span);
    const width = span.offsetWidth;
    document.body.removeChild(span);
    return width;
  };

  /**
   * Converts the privileges array into a formatted structure.
   * @param privileges The array of privileges.
   * @returns The formatted privileges structure.
   */
  convertPrivileges(privileges: any[]): any[] {
    const formattedPrivileges= {};

    privileges.forEach((privilege) => {
      const moduleId = parseInt(privilege.module_id, 10);
      const moduleName = Settings.Module[privilege.module_id];

      // If the module ID does not exist in the formattedPrivileges object,
      // create a new entry for it.
      if (!formattedPrivileges[moduleId]) {
        formattedPrivileges[moduleId] = {
          label: moduleName,
          id: moduleId,
          items: [],
        };
      }

      // Add the privilege to the corresponding module entry.
      formattedPrivileges[moduleId].items.push({
        id: moduleId,
        label: privilege.name.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
        value: privilege.name,
      });
    });

    // Return the formatted privileges as an array.
    return Object.values(formattedPrivileges);
  }
}
